// @slims/shared/branding — white-label per CER (WB-R22 / ADR-004).

export * from './derive';

import type { BrandingFontFamily } from './derive';

/** Branding di una CER, in camelCase, come lo consuma il client. */
export interface OrgBranding {
	organizationId: string;
	appName: string | null;
	tagline: string | null;
	logoUrl: string | null;
	logoDarkUrl: string | null;
	primaryColor: string;
	secondaryColor: string;
	fontFamily: BrandingFontFamily;
	showSlimsLogoOnLogin: boolean;
}

/** Valori di default: brand SLIMS CER. */
export const DEFAULT_ORG_BRANDING: Omit<OrgBranding, 'organizationId'> = {
	appName: null,
	tagline: null,
	logoUrl: null,
	logoDarkUrl: null,
	primaryColor: '#00E5FF',
	secondaryColor: '#7C3AED',
	fontFamily: 'inter',
	showSlimsLogoOnLogin: true,
};

/**
 * Converte la riga snake_case restituita da `get_org_branding` / dalla tabella
 * `organization_branding` nel tipo camelCase `OrgBranding`. Tollera `null`.
 */
export function mapBrandingRow(
	row: Record<string, unknown> | null | undefined,
): OrgBranding | null {
	if (!row || typeof row !== 'object') return null;
	const orgId = (row.organization_id ?? row.organizationId) as string | undefined;
	if (!orgId) return null;
	const str = (v: unknown): string | null => (typeof v === 'string' && v.trim() !== '' ? v : null);
	return {
		organizationId: orgId,
		appName: str(row.app_name ?? row.appName),
		tagline: str(row.tagline),
		logoUrl: str(row.logo_url ?? row.logoUrl),
		logoDarkUrl: str(row.logo_dark_url ?? row.logoDarkUrl),
		primaryColor: str(row.primary_color ?? row.primaryColor) ?? DEFAULT_ORG_BRANDING.primaryColor,
		secondaryColor:
			str(row.secondary_color ?? row.secondaryColor) ?? DEFAULT_ORG_BRANDING.secondaryColor,
		fontFamily: (str(row.font_family ?? row.fontFamily) ?? 'inter') as BrandingFontFamily,
		showSlimsLogoOnLogin:
			(row.show_slims_logo_on_login ?? row.showSlimsLogoOnLogin ?? true) !== false,
	};
}
